import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import UploadFile from '../../../components/core/upload-file/UploadFile';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import styled  from "styled-components" ;
import Stack from '@mui/material/Stack';
import SendIcon from '@mui/icons-material/Send';
import {EXPORT_FORMAT_EXTENDED_VARIABLE_ROWS, EXPORT_FORMAT_FIXED_COLUMN, EXPORT_FORMAT_VARIABLE_COLUMN, type IUploadFormProps} from "../../../components/interface/iUpload"
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";


const MuiFileInputStyled = styled(UploadFile)`
.MuiFileInput-TextField  {
    max-width: 38%;
  }
`

const Form: React.FC<IUploadFormProps> = (
 {
   handleEmailChange,
   handleFileChange,
   handleConfigChange,
   handleExportFormatChange,
   exportConfig,
   isSuccess,
   isLoading,
   progress,
   handleSubmit,
   formValues
 }
) => {
  const {showResultBeforeExport,
    showProjectType,
    showContentSummary,
    showProductCompetitors,
    showProductPricing,
    exportFormat
   } = exportConfig;
  return (
        <Box
          sx={{
            flexGrow: 1,
            padding: 4,
            paddingLeft: '20%',
            paddingRight: '20%',
          }}
        >
         <Stack spacing={2}>
            <TextField
              onChange={handleEmailChange}
              value={formValues.email}
              label="Email"
              name="email"
              sx={{ maxWidth: '38%' }}
            />
             <Stack spacing={2}>
        
           <MuiFileInputStyled
                handleChange={handleFileChange}
                value={formValues.file}          
            />
            </Stack>
      
            <Box marginY={3}>
              {isSuccess ? (
                <Box color="success.main" display="flex">
                  <CheckIcon color="success" />
                  <Typography>Success</Typography>
                </Box>
              ) : (
                <>
                  <FormControlLabel 
                      label={<Typography variant="body2" color="textSecondary">Show Results Before Exporting</Typography>}
                      control={<Checkbox name="showResultBeforeExport" checked={showResultBeforeExport} onChange={handleConfigChange}/>} 
                  />
                  <FormControlLabel 
                      label={<Typography variant="body2" color="textSecondary">Product Categories</Typography>}
                      control={<Checkbox name="showProjectType" checked={showProjectType} onChange={handleConfigChange}/>} 
                  />
                  <FormControlLabel 
                      label={<Typography variant="body2" color="textSecondary">Content Coverage Summary</Typography>}
                      control={<Checkbox name="showContentSummary"  checked={showContentSummary} onChange={handleConfigChange}/>} 
                  />
                  <FormControlLabel 
                      label={<Typography variant="body2" color="textSecondary">Product Service/Alternatives</Typography>}
                      control={<Checkbox name="showProductCompetitors"  checked={showProductCompetitors} onChange={handleConfigChange}/>} 
                  />

                  <FormControlLabel 
                      label={<Typography variant="body2" color="textSecondary">Product Pricing</Typography>}
                      control={<Checkbox name="showProductPricing"  checked={showProductPricing} onChange={handleConfigChange}/>} 
                  />

                 {/* <FormControlLabel 
                      label={<Typography variant="body2" color="textSecondary">Extended Output</Typography>}
                      control={<Checkbox name="showExtendedOutput"  checked={showExtendedOutput} onChange={handleConfigChange}/>} 
                  /> */}

                  <FormControl sx={ { m: 1, minWidth: 120}}>
                      <InputLabel id="outputFormat-label">Output Formats</InputLabel>
                      
                      <Select
                          labelId="outputFormat-label"
                          id="outputFormat"
                          value={exportFormat}
                          label="Output Formats"
                          onChange={handleExportFormatChange}
                        >
                          <MenuItem value={EXPORT_FORMAT_FIXED_COLUMN}>Fixed Column</MenuItem>
                          <MenuItem value={EXPORT_FORMAT_VARIABLE_COLUMN}>Variable Column</MenuItem>
                          <MenuItem value={EXPORT_FORMAT_EXTENDED_VARIABLE_ROWS}>Extended Rows</MenuItem>
                        </Select>

                      
                  </FormControl>


                  <Button  variant="outlined"  endIcon={<SendIcon />} onClick={(e)=>handleSubmit(e)}>Submit Post </Button>
                  {isLoading && <LinearProgress sx={{mt:2}} variant="determinate" value={progress} />}

                </>
              )}
            </Box>
          </Stack>
        </Box>
  );
};

export default Form;
